import React, { useState } from "react";
import gif1 from "./Contact us (1).gif";
import success from "./Mail.gif";
import { db } from "../firebase";
import { IoMdClose } from "react-icons/io";
import { collection, addDoc } from "firebase/firestore";
function Contactus() {
  const [data, setdata] = React.useState({
    name: "",
    email: "",
    textarea: "",
  });
  const [popup, setPopup] = useState(false);
  const [red, setred] = useState(false);
  function InpClicked(e) {
    const { name, value } = e.target;
    setdata((prevdata) => {
      return { ...prevdata, [name]: value };
    });
  }
  async function submit(e) {
    e.preventDefault();
    const name = document.getElementById("name");
    const email = document.getElementById("email");
    const textareaa = document.getElementById("textarea");
    if (name.value === "") {
      setred(true);
    } else if (email.value === "") {
      setred(true);
    } else if (textareaa.value === "") {
      setred(true);
    } else {
      setred(false);

      addDoc(collection(db, "contact"), data)
        .then(() => {
          setPopup(true);
          setdata({ name: "", textarea: "", email: "" });
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  }
  return (
    <div className="mt-[100px] phone:mt-[74px]">
      <div className="slm">
        <div className="bg-primary-100 relative flex justify-center items-center font-font1 text-[50px] w-full h-[250px]">
          <img
            className="absolute object-cover w-full h-[250px]"
            src="https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
            alt="sky"
          />
          <h1 className="z-50 text-gray-900 main-titles text-center">
            Contact Us
          </h1>
        </div>
      </div>
      <div className="flex demitablet:flex-col items-center pt-20 ">
        <div className="pr-20 phone:text-center phone:pr-0 phone:justify-center phone:flex phone:flex-col phone:m-auto">
          <h1 className="main-X-titles font-font1 phone:pr-0 pr-10">
            Let's talk about everything!
          </h1>
          <p className="text-xl phone:text-lg font-font phone:pr-0 pr-10 text-gray-600 my-4">
            Hate forms? Send us an{" "}
            <a
              className="text-primary-100 border-b-2 border-primary-100"
              href="mailto:musashioussama457@gmail.com"
            >
              email
            </a>{" "}
            instead.
          </p>
          <img
            src={gif1}
            className="max-h-[500px] m-auto flex phone:w-full  max-w-[500px] rotate-360"
            alt=""
          />
        </div>

        <>
          {popup && (
            <div
              onClick={() => setPopup(false)}
              className="fixed z-[10000000] inset-0 bg-gray-900 bg-opacity-50  overflow-y-hidden flex justify-center items-center "
            />
          )}
          <div
            className={`${
              popup
                ? "w-auto scale-100 duration-700  max-auto z-[100000000] rounded-lg fixed -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 bg-white shadow-lg"
                : "scale-0  duration-700"
            }`}
          >
            {popup && (
              <div className="flex  flex-col justify-center phonex2:w-[20rem]  w-[35rem] h-[22rem]  ">
                <div className="flex justify-center">
                  {" "}
                  <img src={success} className="max-h-[200px] " alt="" />
                </div>
                <div className="flex flex-col justify-center">
                  <h1 className="flex justify-center text-[30px] font-font1">
                    Success!
                  </h1>
                  <p className="font-font flex justify-center">
                    your email has been sent.
                  </p>
                </div>
              </div>
            )}

            <div
              onClick={() => setPopup(false)}
              className="fixed right-0 cursor-pointer -top-16 bg-primary-100 w-12 h-12 rounded-full flex justify-center items-center"
            >
              <IoMdClose className="text-white text-xl" />
            </div>
          </div>{" "}
        </>

        <form
          onSubmit={submit}
          className="w-full space-y-10 phone:space-y-4 phone:px-14 phonex2:px-0"
        >
          <div className="flex flex-col w-full">
            <label
              className={`${
                red
                  ? "uppercase text-sm  font-font1 mb-4 text-red-500"
                  : "uppercase text-sm text-gray-600 font-font1 mb-4"
              }`}
              htmlFor="name"
            >
              First name
            </label>
            <input
              pattern="[A-Za-z]{3,8}"
              onChange={InpClicked}
              value={data.name}
              className={`${
                red
                  ? "w-full bg-primary-100/20 rounded-lg h-12 border-[1px] border-red-500 outline-none px-4 py-4"
                  : "w-full bg-primary-100/20 rounded-lg h-12 border-[1px] border-primary-100 outline-none px-4 py-4"
              }"w-full bg-primary-100/20 rounded-lg h-12 outline-none px-4 py-4"`}
              type="text"
              name="name"
              id="name"
            />
          </div>
          <div className="flex flex-col">
            <label
              className={`${
                red
                  ? "uppercase text-sm  font-font1 mb-4 text-red-500"
                  : "uppercase text-sm text-gray-600 font-font1 mb-4"
              }`}
              htmlFor="email"
            >
              EMAIL{" "}
            </label>
            <input
              className={`${
                red
                  ? "w-full rounded-lg border-[1px] border-red-500  h-12 bg-primary-100/20 outline-none px-4 py-4"
                  : "w-full border-[1px] border-primary-100 rounded-lg  h-12 bg-primary-100/20 outline-none px-4 py-4"
              }`}
              type="email"
              value={data.email}
              onChange={InpClicked}
              name="email"
              id="email"
            />
          </div>
          <div className="flex flex-col">
            <label
              className={`${
                red
                  ? "uppercase text-sm  font-font1 mb-4 text-red-500"
                  : "uppercase text-sm text-gray-600 font-font1 mb-4"
              }`}
              htmlFor="textarea"
            >
              MESSAGE{" "}
            </label>
            <textarea
              type="text"
              value={data.textarea}
              pattern="[A-Za-z]{10}"
              onChange={InpClicked}
              className={`${
                red
                  ? "w-full h-32  rounded-lg border-[1px] border-red-500    bg-primary-100/20  outline-none px-4 py-4"
                  : "w-full h-32 border-[1px] border-primary-100  rounded-lg    bg-primary-100/20  outline-none px-4 py-4"
              }`}
              name="textarea"
              id="textarea"
            ></textarea>
          </div>
          <div>
            <button className="bg-primary-100 tracking-wide	 mt-10 uppercase space-x-32 h-14 w-full rounded-md text-white font-font1 ">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contactus;
